// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"813883ae","563":"7e3e225e","787":"2fde9e08"}[chunkId] + ".chunk.js";
};